import { newRelicJSError } from "./analytics/new_relic_helper";

export default function outbrainTrackLead() {
    try {
        obApi('track','Lead Conversion');
    } catch (err) {
        const error = "Error firing Outbrain Lead Track Pixel: " + err;
        newRelicJSError(error);
        console.error(error);
    }
}
